import React, { useEffect } from 'react';

import Button from '@amzn/meridian/button';
import Modal from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import useForm from 'src/hooks/useForm';
import JmrService from 'src/services/jmr/jmrService';
import { createFileUrl, downloadFile } from 'src/utils/fileUtils';

import InjuryInfo from './injuryInfo/injuryInfo';

export interface OomdForm {
  injury: string;
  dateOfInjury: string;
  dateOfInjuryReportedToAmcare: string;
  additionalNotes: string;
}

interface OomdModalProps {
  placementId: number;
  isOomdModalOpen: boolean;
  closeModal: VoidFunction;
}

const OomdModal = ({ placementId, isOomdModalOpen, closeModal }: OomdModalProps) => {
  const { handleChangeDynamicKey, formData, resetForm } = useForm<OomdForm>();

  useEffect(() => {
    resetForm();
  }, []);

  const downloadOOMD = async () => {
    const response = await JmrService.downloadOOMD({
      accommodationId: placementId,
      injury: formData.injury || '',
      reportDate: formData.dateOfInjury || '',
      reportDateToAMCARE: formData.dateOfInjuryReportedToAmcare || '',
      additionalNotes: formData.additionalNotes || '',
    });

    if (response.data) {
      downloadFile(createFileUrl(response.data, 'application/pdf'), 'oomd-form.pdf');
      resetForm();
      closeModal();
    }
  };

  return (
    <Modal title="Offer of Modified Duties" open={isOomdModalOpen} onClose={closeModal} width={'780px'}>
      <InjuryInfo handleChange={handleChangeDynamicKey} oomdFormData={formData} />

      <Row widths={['fill', '244px']}>
        <div />
        <Row>
          <Button
            onClick={() => {
              resetForm();
              closeModal();
            }}
          >
            Cancel
          </Button>
          <Button onClick={downloadOOMD}>Generate PDF</Button>
        </Row>
      </Row>
    </Modal>
  );
};

export default OomdModal;
